import classNames from "classnames";
import AscProgressBar from "../../AscProgressBar/AscProgressBar";
import styles from "./AscTrackProgressCard.module.scss";
import { AscBadgeColor } from "@ascendnow/shared";

export interface AscTrackProgressCardProps {
  title: string;
  grade: number;
  completedModules: number;
  totalModules: number;
  color?: AscBadgeColor;
  locked?: boolean;
  className?: string;
}

export default function AscTrackProgressCard({
  title,
  grade,
  completedModules = 0,
  totalModules = 1,
  color,
  locked,
  className,
}: AscTrackProgressCardProps) {
  return (
    <div
      className={classNames(
        styles.element,
        {
          [styles.teal]: color === "TEAL",
          [styles.pink]: color === "PINK",
          [styles.purple]: color === "PURPLE",
          [styles.green]: color === "GREEN",
          [styles.orange]: color === "ORANGE",
          [styles.locked]: locked,
        },
        className
      )}
    >
      <div className={styles.top}>
        <h5 className={styles.title}>{title}</h5>
      </div>
      <div className={styles.bottom}>
        <div className={styles.grade}>
          <div>Grade</div>
          <div>{grade % 1 === 0 ? grade : grade.toFixed(2)}%</div>
        </div>
        <AscProgressBar value={grade} color={color} locked={locked} fullWidth />
        <div className={styles.modules}>
          <div>Modules</div>
          <div>
            {completedModules}/{totalModules}
          </div>
        </div>
      </div>
    </div>
  );
}
